// extracted by mini-css-extract-plugin
export default {"slideshowWindow":"PanelSlideshow_slideshowWindow__H3+oz","slideImage":"PanelSlideshow_slideImage__Ouz4w","slideImageActive":"PanelSlideshow_slideImageActive__i138l"};